import React from "react";
import {Popover} from "antd";

export const getPrescriptionDrugAmountOptions = (mult = 1) => {
    const arr =  [];
    for (let i = 1; i <= mult * 2; i++) arr.push({label: String(i), value: String(i)});
    return arr;
}

export const prescriptionParticipationPercentageOptions = [
    { value: "1", label: "0%" },
    { value: "10", label: "10%" },
    { value: "25", label: "25%" },
    // { value: "100", label: "100%" },
]

export const prescriptionDoseAmountOptions = [
    { value: "0.25", label: "0.25" },
    { value: "0.5", label: "0.5" },
    { value: "1", label: "1" },
    { value: "1.5", label: "1.5" },
    { value: "2", label: "2" },
    { value: "2.5", label: "2.5" },
    { value: "3", label: "3" },
    { value: "3.5", label: "3.5" },
    { value: "4", label: "4" },
    { value: "4.5", label: "4.5" },
    { value: "5", label: "5" },
    { value: "5.5", label: "5.5" },
    { value: "6", label: "6" },
    { value: "6.5", label: "6.5" },
    { value: "7", label: "7" },
    { value: "7.5", label: "7.5" },
    { value: "8", label: "8" },
    { value: "8.5", label: "8.5" },
    { value: "9", label: "9" },
    { value: "9.5", label: "9.5" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
]

export const prescriptionFrequencyOptions = [ // Attention to backend matching (function prescriptionFrequency(...))
    { label: "1 φορά την ημέρα", value: "1perday" },
    { label: "2 φορές την ημέρα", value: "2perday" },
    { label: "3 φορές την ημέρα", value: "3perday" },
    { label: "4 φορές την ημέρα", value: "4perday" },

    { label: "1 φορά την εβδομάδα", value: "1perweek" },
    { label: "2 φορές την εβδομάδα", value: "2perweek" },
    { label: "3 φορές την εβδομάδα", value: "3perweek" },

    { label: "κάθε 2 εβδομάδες", value: "every2weeks" },
    { label: "κάθε 4 εβδομάδες", value: "every4weeks" },
    { label: "κάθε 8 εβδομάδες", value: "every8weeks" },
    { label: "κάθε 12 εβδομάδες", value: "every12weeks" },

    { label: "εφάπαξ", value: "forever" },
    { label: "επί πόνου", value: "pain" },
    { label: "επί δύσπνοιας", value: "breath" },
]

export const newVisitOverrideOptions = [
    { label: "Ημερήσια νοσηλεία", value: "506"},
    { label: "Εξερχόμενος ασθενής", value: "507"},
    { label: "Δεν υπήρχε νοσηλεία", value: "508"},
    { label: "Ο ασθενής έχει λάβει εξιτήριο", value: "489"},
]

export const getMultiselectICD10sOptions = (icd10s = []) => {
    return [{value: "all", label: "Όλες"}, ...icd10s.map((o) => {
        return {
            value: o.code,
            label: `${o.code} ${o.title}`,
        }
    })]
}

export const asArray = (obj) => {
    if (obj) {
        if (Array.isArray(obj)) {
            return obj;
        } else {
            return [obj];
        }
    }
    return [];
}

export const referralTypeOptions = [
    {label: "Τυπικό", value: "1"},
    // {label: "Ελεύθερο", value: "2"}, // Unavailable
]

export const textToLines = (text, separator = "|") => {
    const length = String(text).split("|").length;
    if (length === 0 || length === 1 || !length) {
        return (
            <React.Fragment>{text}</React.Fragment>
        )
    } else {
        return (
            <div>
                {text.split(separator).map((line, index) => (
                    <div key={index}>- {line}</div>
                ))}
            </div>
        )
    }
}

export const bigTextComponent = (text) => {
    const bigTextVal = 80;
    const isBig = String(text).length >= bigTextVal;
    if (isBig) {
        return (
            <Popover placement={"top"} title={
                <div style={{textAlign: "center"}}><u>Περιγραφή Θεραπευτικού Πρωτοκόλλου</u></div>
            } content={
                <div style={{maxWidth: "500px", maxHeight: "300px", overflowY: "auto"}} dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }}>
                </div>
            }>
                <span>{String(text).slice(0, bigTextVal)}...</span>
            </Popover>
        )
    } else {
        return <span>{text}</span>
    }
}

export const formatPrescriptionStatus = (st) => {
    if (st === "new") {
        return "Συνταγογραφημένη";
    } else if (st === "completed") {
        return "Εκτελεσμένη";
    } else if (st === "active") {
        return "Μερικώς Εκτελεσμένη";
    } else if (st === "cancelled") {
        return "Ακυρωμένη";
    } else if (st === "held") {
        return "Υπο Θεώρηση/Προσωρινά Συνταγογραφημένη";
    } else if (st === "aborted") {
        return "Απορριφθείσα";
    } else {
        return st;
    }
}

export const getPrescriptionColor = (st) => {
    if (st === "new") {
        return "#dfebff";
    } else if (st === "completed") {
        return "#d1facd";
    } else if (st === "active") {
        return "#d1facd";
    } else if (st === "cancelled") {
        return "#ffd1c9";
    } else if (st === "held") {
        return "#fbfcca";
    } else if (st === "aborted") {
        return "#ffd1c9";
    } else {
        return st;
    }
}

export const getActiveSubstance = (drug) => {
    let val = "";
    if (drug.activeSubstances.activeSubstance) {
        if (Array.isArray(drug.activeSubstances.activeSubstance)) {
            val = drug.activeSubstances.activeSubstance.find((el) => el.mainActiveSubstance === "true")?.activeSubstance?.description;
        } else {
            val = drug.activeSubstances.activeSubstance.activeSubstance.description;
        }
    }
    return val;
}

export const linkify = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return String(text).split(urlRegex).map((part, index) =>
        urlRegex.test(part) ? (
            <span><br/><a key={index} href={part} target="_blank" rel="noopener noreferrer">
                    {part}
                </a></span>
        ) : (
            part
        )
    )
}

export const greekMonthsSecondFormat = {
    "01": "Ιανουαρίου",
    "02": "Φεβρουαρίου",
    "03": "Μαρτίου",
    "04": "Απριλίου",
    "05": "Μαΐου",
    "06": "Ιουνίου",
    "07": "Ιουλίου",
    "08": "Αυγούστου",
    "09": "Σεπτεμβρίου",
    "10": "Οκτωβρίου",
    "11": "Νοεμβρίου",
    "12": "Δεκεβρίου",
}
